import stickerUrl from './assets/stickers.webp';
import dogUrl from './assets/angry-dog.png';
import characterUrl from './assets/photo-character.png';
import normalUrl from './assets/normal-character.png';
// Keep the animal atlas separate so personal character updates preserve the cats and dogs.
import { CHARACTER_MASKS as BASE_CHARACTER_MASKS } from './character-masks.mjs';
import { NORMAL_MASK } from './normal-mask.mjs';
import { DOG_MASK } from './dog-mask.mjs';
const CHARACTER_MASKS = { ...BASE_CHARACTER_MASKS, normal: NORMAL_MASK };
export { CHARACTER_MASKS, DOG_MASK };
export const ART_URL = stickerUrl;
export const ATLAS_SIZE = { width: 1536, height: 1024 };
export const DOG_ART = { url: dogUrl, width: 1254, height: 1254 };
export const CHARACTER_ART = { url: characterUrl, width: 1536, height: 1024 };
export const NORMAL_ART = { url: normalUrl, width: 1536, height: 1024 };
export const FRAMES = {
  cat0: { x: 38, y: 12, w: 465, h: 413 },
  cat1: { x: 540, y: 11, w: 460, h: 408 },
  cat2: { x: 1038, y: 12, w: 455, h: 411 },
  dog: { texture: 'dog', x: 8, y: 115, w: 1238, h: 990 },
  normal: { texture: 'normal-character', x: 107, y: 22, w: 660, h: 998 },
  happy: { texture: 'character', x: 107, y: 22, w: 660, h: 998 },
  sad: { texture: 'character', x: 767, y: 22, w: 660, h: 998 },
};
export const CHARACTER = {
  texture: 'character',
  normal: 'normal',
  happy: 'happy',
  sad: 'sad',
  basketHeightRatio: 0.35,
  basketHalfWidthRatio: 0.3,
};
export function decorateStickers() {
  document.querySelectorAll('[data-art]').forEach((el) => {
    const f = FRAMES[el.dataset.art];
    const sheet =
      f.texture === 'normal-character'
        ? NORMAL_ART
        : f.texture === 'character'
          ? CHARACTER_ART
          : f.texture === 'dog'
            ? DOG_ART
            : { url: ART_URL, ...ATLAS_SIZE };
    el.style.backgroundImage = `url('${sheet.url}')`;
    el.style.aspectRatio = `${f.w} / ${f.h}`;
    el.style.backgroundSize = `${(sheet.width / f.w) * 100}% ${(sheet.height / f.h) * 100}%`;
    el.style.backgroundPosition = `${sheet.width === f.w ? 0 : (f.x / (sheet.width - f.w)) * 100}% ${sheet.height === f.h ? 0 : (f.y / (sheet.height - f.h)) * 100}%`;
    const outline = el.dataset.art === 'dog' ? DOG_MASK : CHARACTER_MASKS[el.dataset.art];
    if (outline)
      el.style.clipPath = `polygon(${outline.map(([x, y]) => `${(x / f.w) * 100}% ${(y / f.h) * 100}%`).join(',')})`;
  });
}
